// extracted by mini-css-extract-plugin
export default {"activationPaymentsModal":"styles_activationPaymentsModal__rc+WC","activationPaymentsModalButton":"styles_activationPaymentsModalButton__JP4Wi"};